// Shared ComIQ design tokens — extracted & verified from comiq.id / insights.
export const COLORS = {
  paper: "#F5F1E8",
  surface: "#FCFAF4",
  surfaceAlt: "#FFFFFF",
  ink: "#17140F",
  textSoft: "#6A6256",
  orange: "#F2541B",
  orangeInk: "#C43C0A",
  orangeDeep: "#D4470F",
  line: "#E4DCCB",
  lineStrong: "#D8CFBB",
};

// Chart palette: orange leads sparingly; the rest are distinct & accessible.
export const CHART_COLORS = ["#F2541B", "#17140F", "#0F766E", "#1D4ED8", "#B45309", "#6D28D9"];

// Status + data-quality colors (never orange, to keep orange for primary actions).
export const STATUS = {
  complete: { label: "Selesai", fg: "#15803D", bg: "#DCFCE7" },
  progress: { label: "Berjalan", fg: "#B45309", bg: "#FEF3C7" },
  invited: { label: "Diundang", fg: "#1D4ED8", bg: "#DBEAFE" },
  expired: { label: "Kedaluwarsa", fg: "#57534E", bg: "#EEEAE0" },
  flagged: { label: "Perlu ditinjau", fg: "#B42318", bg: "#FEE4E2" },
};

export const RADII = { sm: "10px", base: "16px", lg: "24px", pill: "999px" };

export const TYPE_SCALE = [
  { name: "Display / H1 (serif)", cls: "font-serif-editorial text-4xl sm:text-5xl", sample: "Commercial intelligence" },
  { name: "H2 (serif)", cls: "font-serif-editorial text-3xl", sample: "The evidence behind" },
  { name: "H3 (sans)", cls: "font-sans font-semibold text-xl", sample: "Section heading" },
  { name: "Body (Inter)", cls: "font-sans text-base", sample: "Readable body copy for questions and prose." },
  { name: "Eyebrow", cls: "eyebrow", sample: "ComIQ Research" },
];
